module.exports = __webpack_public_path__ + "img/logo-feelgood-light-linebreak.d81b6115.svg";